import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { Button, Modal, Radio, DatePicker, Popover, Checkbox, message } from 'ant-design-vue'
import '@/common/filters'

moment.locale('zh-cn')

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(Button)
Vue.use(Modal)
Vue.use(Radio)
Vue.use(DatePicker)
Vue.use(Popover)
Vue.use(Checkbox)
Vue.prototype.$message = message
Vue.prototype.moment = moment
Vue.prototype.$warning = Modal.warning
Vue.prototype.$error = Modal.error
Vue.prototype.$confirm = Modal.confirm

Vue.filter('stopCity', (value) => {
  if (!value) {
    return '-'
  }

  return value.map(item => item.stopAirportName + item.stopCityTerm).join(',')
})
